import { AppointmentType, PtEntity, PtUiAppRoutes } from '@pt/pt-models';
import { AppQueryParams } from './app-query-params';

export class AppLinkBuilder {
  public static profileLink() {
    const host = `${window.location.protocol}//${window.location.host}`;
    return `${host}/${PtUiAppRoutes.PROFILE}`;
  }

  public static linkOfWorkspace(folderId: number) {
    const host = `${window.location.protocol}//${window.location.host}`;
    return `${host}/${PtUiAppRoutes.WORKSPACE}/${PtUiAppRoutes.RESOURCES}/${folderId}`;
  }

  public static linkOfEntity(entity: PtEntity, entityId: number | string): string {
    const host = `${window.location.protocol}//${window.location.host}`;
    let url = null;
    let isDocument = false;
    switch (entity) {
      case 'projectCards':
        url = `${host}/${PtUiAppRoutes.BUSINESS_MANAGEMENT}/${PtUiAppRoutes.PROJECT_CARDS}`;
        isDocument = true;
        break;
      case 'treatmentsHolder':
        url = `${host}/${PtUiAppRoutes.BUSINESS_MANAGEMENT}/${PtUiAppRoutes.TREATMENTS_HOLDER}`;
        isDocument = true;
        break;
      case 'treatmentsResponsible':
        url = `${host}/${PtUiAppRoutes.BUSINESS_MANAGEMENT}/${PtUiAppRoutes.TREATMENTS_RESPONSIBLE}`;
        isDocument = true;
        break;
      case 'globalMeasureCheck':
        url = `${host}/${PtUiAppRoutes.BUSINESS_MANAGEMENT}/${PtUiAppRoutes.GLOBAL_MEASURE_CHECK}`;
        isDocument = true;
        break;
      case 'appAssessment':
        url = `${host}/${PtUiAppRoutes.BUSINESS_MANAGEMENT}/${PtUiAppRoutes.APP_ASSESSMENTS}`;
        isDocument = true;
        break;
      case 'aiAssessment':
        url = `${host}/${PtUiAppRoutes.BUSINESS_MANAGEMENT}/${PtUiAppRoutes.AI_ASSESSMENTS}`;
        isDocument = true;
        break;
      case 'applications':
        url = `${host}/${PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE}/${PtUiAppRoutes.APPLICATIONS}`;
        break;
      case 'appointments':
        url = `${host}/${PtUiAppRoutes.BUSINESS_MANAGEMENT}/${PtUiAppRoutes.APPOINTMENTS}`;
        break;
      case 'appointmentsSystemAdmin':
        //todo fix backtick new line char issue @nik
        url = `${host}/${PtUiAppRoutes.BUSINESS_MANAGEMENT}/${PtUiAppRoutes.APPOINTMENTS}?${AppQueryParams.APPOINTMENTS_TAB}=${AppQueryParams.appointmentsTabAvailableValues[AppointmentType.APPOINTMENT_SYSTEM_ADMIN]}`;
        break;
      case 'appointmentsAuthorized':
        url = `${host}/${PtUiAppRoutes.BUSINESS_MANAGEMENT}/${PtUiAppRoutes.APPOINTMENTS}?${AppQueryParams.APPOINTMENTS_TAB}=${AppQueryParams.appointmentsTabAvailableValues[AppointmentType.APPOINTMENT_AUTHORIZED]}`;
        break;
      case 'appointmentsResponsible':
        url = `${host}/${PtUiAppRoutes.BUSINESS_MANAGEMENT}/${PtUiAppRoutes.APPOINTMENTS}?${AppQueryParams.APPOINTMENTS_TAB}=${AppQueryParams.appointmentsTabAvailableValues[AppointmentType.APPOINTMENT_RESPONSIBLE]}`;
        break;
      case 'recipients':
        url = `${host}/${PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE}/${PtUiAppRoutes.RECIPIENTS}`;
        break;
      case 'userResources':
        url = `${host}/${PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE}/${PtUiAppRoutes.USERS_RESOURCES}`;
        break;
      case 'organizationalMeasures':
        url = `${host}/${PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION}/${PtUiAppRoutes.SECURITY_MEASURES}`;
        break;
      case 'organizationalMeasureCategories':
        url = `${host}/${PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION}/${PtUiAppRoutes.SECURITY_MEASURE_CATEGORIES}`;
        break;
      case 'technicalMeasureCategories':
        url = `${host}/${PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION}/${PtUiAppRoutes.TECHNICAL_MEASURE_CATEGORIES}`;
        break;
      case 'technicalMeasures':
        url = `${host}/${PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION}/${PtUiAppRoutes.TECHNICAL_MEASURES}`;
        break;
      case 'legalEntity':
        url = `${host}/${PtUiAppRoutes.DATA_PROTECTION_GOVERNANCE}/${PtUiAppRoutes.LEGAL_ENTITY}`;
        break;
      case 'users':
        url = `${host}/${PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION}/${PtUiAppRoutes.USERS}`;
        break;
      case 'userGroups':
        url = `${host}/${PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION}/${PtUiAppRoutes.USER_GROUPS}`;
        break;
    }

    if (isDocument) {
      url += `/${PtUiAppRoutes.EDIT}/${entityId?.toString()}`;
      return url;
    }

    if (url !== null) {
      const params = `${AppQueryParams.DETAILS_OPENED}=${AppQueryParams.detailsOpenedAvailableValues.true}&${AppQueryParams.ENTITY_ID}=${entityId?.toString()}`;
      return `${url}${url.includes('?') ? '&' + params : '?' + params}`;
    }
    return null;
  }
}
